'use client'

import { useEffect } from 'react'
import { useUser } from '@/contexts/UserContext'

interface DynamicTitleProps {
  suffix?: string
}

export function DynamicTitle({ suffix }: DynamicTitleProps) {
  const { platformName, loading } = useUser()

  useEffect(() => {
    if (!loading) {
      document.title = suffix ? `${platformName} - ${suffix}` : platformName
    }
  }, [platformName, suffix, loading])

  return null
}